( function () {
    'use strict';
    co3.util = {};
    // Bind funktion der cleare default-values p&aring; tekstfelter p&aring; fokus
    co3.util.bindFormTextFieldDefaultValueToggling = function () {
        jQuery( 'input[type="text"],textarea' ).on( 'focus', function () {
            if ( this.value === this.defaultValue ) {
                this.value = '';
            }
        } ).on( 'blur', function () {
            if ( this.value === '' ) {
                this.value = this.defaultValue;
            }
        } );
    };
    // Konstruer et object indeholdende alle querystringens parametre
    co3.util.param = ( function () {
        var vars = [],
            hash,
            hashes = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );
        for ( var i = 0; i < hashes.length; i++ ) {
            hash = hashes[ i ].split( '=' );
            vars.push( hash[ 0 ] );
            vars[ hash[ 0 ] ] = decodeURIComponent( hash[ 1 ] ).replace( /\+/g, ' ' );
        }
        return vars;
    } )();
    //konverter rgb(a) værdier til hex
    co3.util.rgb2hex = function ( rgb ) {
        function hex( x ) {
            return ( '0' + parseInt( x ).toString( 16 ) ).slice( -2 );
        }
        if ( rgb.search( 'rgb' ) === -1 ) {
            return rgb;
        }
        else {
            rgb = rgb.match( /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/ );
            return '#' + hex( rgb[ 1 ] ) + hex( rgb[ 2 ] ) + hex( rgb[ 3 ] );
        }
    };
    co3.util.formatNumber = function formatNumber( number ) {
        //TODO: lav funktion der kan afrunde matematisk
        //http://www.sacah.net/2011/01/javascript-format-number-price-amount.html
        number = String( parseFloat( Math.round( number * 100 ) / 100 ).toFixed( 2 ) ).replace( /[^\d\.\-]/g, '' ).replace( /(\.\d{2})[\W\w]+/g, '$1' ).split( '' ).reverse().join( '' ).replace( /(\d{3})/g, '$1.' ).split( '' ).reverse().join( '' ).replace( /^([\-]{0,1})\./, '$1' ).replace( /\.(\d\d)$/, ',' + '$1' ).replace( /\.(\d)$/, ',' + '$1' + '0' ).replace( /\.$/, ',00' );
        if ( espresso.config.pageLanguage !== 'da' ) {
            number = number.replace( /\./g, '{integer}' );
            number = number.replace( /\,/g, '{decimal}' );
            number = number.replace( new RegExp( '{integer}', 'g' ), espresso.config.IntergerSeparator );
            number = number.replace( new RegExp( '{decimal}', 'g' ), espresso.config.DecimalSeparator );
        }
        return number;
    };
    co3.util.formatNumberToJavascript = function ( number ) {
        return parseFloat( String( number ).replace( espresso.config.regExpIntergerSeparator, '' ).replace( espresso.config.regExpDecimalSeparator, '.' ) );
    };
    // Smooth scrolling
    co3.util.scroll = {};
    co3.util.scroll.init = function () {
        co3.util.scroll.isAnimating = false;
        co3.util.scroll.loadEasing();
        co3.util.scroll.toAnchor();
    };
    co3.util.scroll.loadEasing = function () {
        co3.util.scroll.easing = 'swing';
        jQuery.ajax( {
            url: '//cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.3/jquery.easing.min.js',
            dataType: 'script',
            timeout: 500,
            cache: true
        } ).success( function () {
            co3.util.scroll.easing = 'easeInOutExpo';
        } );
    };
    co3.util.scroll.toAnchor = function () {
        jQuery( 'a[href*="#"]' ).on( 'click', function ( event ) {
            if ( location.pathname.replace( /^\//, /"\// ) === this.pathname.replace( /^\//, /"\// ) && location.hostname === this.hostname ) {
                var target = this.hash,
                    jTarget = ( target === '#top' ) ? espresso.constant.jHtml : jQuery( 'a[name="' + target.substr( 1 ) + '"]' );
                event.preventDefault();
                co3.util.scroll.toElement( jTarget, 0, true, true );
            }
        } );
        if ( location.hash !== '' ) {
            co3.util.scroll.toElement( jQuery( 'a[name="' + location.hash.substr( 1 ) + '"]' ), 0, true );
        }
    };
    co3.util.scroll.toElement = function ( jTarget ) {
        jTarget = jTarget.first();
        if ( jTarget.length === 1 ) {
            var extraOffset = arguments[ 1 ] || 0,
                allowNegative = arguments[ 2 ] || false,
                allowInViewport = arguments[ 3 ] || false,
                systemAdjustment = 0,
                jStickyNav = jQuery( '.js-e-nav-sticky-wrapper' ),
                scrollTarget = 0;
            systemAdjustment = parseInt( jTarget.css( 'font-size' ), 10 );
            if ( jStickyNav.length > 0 ) {
                systemAdjustment += jStickyNav.outerHeight();
            }
            if ( extraOffset > 0 ) {
                systemAdjustment = 0;
            }
            scrollTarget = jTarget.offset().top - systemAdjustment + extraOffset;
            //console.log( co3.util.scroll.isAnimating === false, (espresso.util.isInViewport( jTarget ) === false || allowInViewport === true) , ( scrollTarget >espresso.constant.jWindow.scrollTop() || allowNegative === true ) );
            if ( ( espresso.util.isInViewport( jTarget ) === false || allowInViewport === true ) && ( scrollTarget > espresso.constant.jWindow.scrollTop() || allowNegative === true ) ) {
                co3.util.scroll.toPosition( scrollTarget );
            }
        }
    };
    co3.util.scroll.toPosition = function ( scrollTarget ) {
        scrollTarget = parseFloat( scrollTarget );
        if ( co3.util.scroll.isAnimating === false ) {
            co3.util.scroll.isAnimating = true;
            jQuery( 'html,body' ).animate( {
                scrollTop: scrollTarget
            }, espresso.settings.scrollSpeed, co3.util.scroll.easing, function () {
                co3.util.scroll.isAnimating = false;
            } );
        }
    };
    co3.util.validateEmail = function ( emailAddress ) {
        var validEmailRegExp = new RegExp( /[a-zæ&oslash;&aring;0-9_\+\-]+(\.[a-zæ&oslash;&aring;0-9_\+\-]+)*@[a-zæ&oslash;&aring;0-9\-]+(\.[a-zæ&oslash;&aring;0-9\-]+)*\.([a-z]{2,6})$/i );
        return validEmailRegExp.test( emailAddress );
    };
}() );
